[
  {
    "id": "GET-M8-L303-001",
    "module": "Getalbegrip",
    "difficulty": 303,
    "question": "Schat de uitkomst: 49,8 $\\times$ 20,1",
    "options": [
      "1000",
      "100",
      "800",
      "1200"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "schatten",
    "familyId": "GET-SCHATTEN",
    "explanation": "Rond af naar 50 $\\times$ 20. Dat is 1000.",
    "distractorExplanations": {
      "1": "100 is veel te klein. 49,8 $\\times$ 20,1 is ongeveer 50 $\\times$ 20 = 1000.",
      "2": "Je rondde 49,8 af naar 40 in plaats van 50. 49,8 ligt dichter bij 50.",
      "3": "Je rondde 20,1 af naar 24 of 25. Maar 20,1 is bijna precies 20."
    }
  },
  {
    "id": "GET-M8-L303-002",
    "module": "Getalbegrip",
    "difficulty": 303,
    "question": "Reken uit: 12 : 0,25 =",
    "options": [
      "48",
      "3",
      "30",
      "4,8"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen",
    "familyId": "GET-DELEN-KOMMA",
    "explanation": "Delen door 0,25 is hetzelfde als vermenigvuldigen met 4. 12 $\\times$ 4 = 48.",
    "distractorExplanations": {
      "1": "Je vermenigvuldigde met 0,25 in plaats van te delen. 12 $\\times$ 0,25 = 3. Maar delen door 0,25 geeft een groter getal.",
      "2": "Je maakte een schatting maar rekende niet precies. Delen door 0,25 = keer 4.",
      "3": "Je verschoof de komma verkeerd. 12 : 0,25 = 12 $\\times$ 4 = 48, niet 4,8."
    }
  },
  {
    "id": "GET-M8-L303-003",
    "module": "Getalbegrip",
    "difficulty": 303,
    "question": "Wat is het gemiddelde van 5,5 en 8,5?",
    "options": [
      "7",
      "6,5",
      "7,5",
      "14"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "gemiddelde",
    "familyId": "GET-GEMIDDELDE",
    "explanation": "5,5 + 8,5 = 14. 14 : 2 = 7.",
    "distractorExplanations": {
      "1": "Je rekende (5,5 + 8,5) : 2 verkeerd uit. De som is 14, gedeeld door 2 is 7, niet 6,5.",
      "2": "Je rondde naar boven af. Het gemiddelde is precies 7, niet 7,5.",
      "3": "Dit is de som van beide getallen. Je moet nog delen door 2 om het gemiddelde te krijgen."
    }
  },
  {
    "id": "GET-M8-L303-004",
    "module": "Getalbegrip",
    "difficulty": 303,
    "question": "Welk getal is 1000 keer zo klein als 45?",
    "options": [
      "0,045",
      "0,45",
      "0,0045",
      "45000"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen",
    "familyId": "GET-KOMMA-SCHUIVEN",
    "explanation": "De komma schuift 3 plekken naar links. 45 → 4,5 → 0,45 → 0,045.",
    "distractorExplanations": {
      "1": "Je schoof de komma maar 2 plekken naar links (dat is 100 keer zo klein). Je moet 3 plekken schuiven voor 1000 keer.",
      "2": "Je schoof de komma 4 plekken naar links (dat is 10.000 keer zo klein). 1000 keer = 3 plekken.",
      "3": "Je vermenigvuldigde met 1000 in plaats van te delen. '1000 keer zo klein' betekent delen door 1000."
    }
  },
  {
    "id": "GET-M8-L303-005",
    "module": "Getalbegrip",
    "difficulty": 303,
    "question": "Hoeveel is $\\frac{5}{8}$ deel van 64?",
    "options": [
      "40",
      "35",
      "45",
      "32"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "$\\frac{1}{8}$ van 64 is 8. $\\frac{5}{8}$ is 5 $\\times$ 8 = 40.",
    "distractorExplanations": {
      "1": "Je rekende $\\frac{4}{8}$ (de helft is 32) plus nog iets, maar kwam op 35. Controleer: 5 $\\times$ 8 = 40.",
      "2": "Je rekende $\\frac{6}{8}$ in plaats van $\\frac{5}{8}$. 6 $\\times$ 8 = 48, niet 45.",
      "3": "Dit is de helft ($\\frac{4}{8}$) van 64. Maar $\\frac{5}{8}$ is meer dan de helft."
    }
  }
]